
import { Flex, Heading, SkeletonLoader } from "@braze/beacon-core"
import styled from "styled-components"
import { Card } from "./Card"
import { AnalysisTable } from "./table/AnalysisTable"
import { TotalMetrics } from "./metrics/TotalMetrics"
import { FunnelGraph } from "./metrics/FunnelGraph"
import { AnalysisFilters } from "./filters/AnalysisFilters"
import { useAnalysisContext } from "../../contexts/AnalysisContext"



export const AnalysisView = (() => {

    const { analysisLoading } = useAnalysisContext()

    return (

        <MainContainer direction="column">
            <Flex style={{marginLeft: "2rem", marginRight: "2rem"}}>
                <Card style={{width: "100%", marginBottom: "1rem"}}>
                    <AnalysisFilters/>
                </Card> 
            </Flex>
            {analysisLoading &&
                <Flex direction="column" style={{width: "100%", height: "100%", marginBottom: "2rem"}}>
                    {/* <Label style={{fontSize: "16px"}}>
                        <pre>
                            {`
                            Because of the amount of data being pulled, the first load may take over 30s up to a minute.\n
                            Please be patient and wait for the skeleton loader to disapper and the results to display.\n
                            After the initial sync, querying results with filters will be much faster.\n
                            If it takes longer than 90s, try refreshing the page.
                            `}
                        </pre>
                    </Label>  */}
                    
                    <SkeletonLoader/>
                </Flex>
                
            }     
            {!analysisLoading && <Flex direction="column" style={{marginLeft: "2rem", marginRight: "2rem"}}>
                <Flex>
                    <Card style={{width: "50%"}}>
                        <Heading level={2} style={{marginBottom: "1rem"}}>Cumulative Metrics</Heading>
                        <TotalMetrics/>    
                    </Card>
                    <Card style={{width: "100%", marginLeft:"1rem"}}>
                        <Heading level={2} style={{marginBottom: "1rem"}}>Cumulative Funnel</Heading>
                        <FunnelGraph/>
                    </Card>
                </Flex>
                <Card style={{marginTop:"1rem"}}>
                    <Heading level={2}>Campaigns Table</Heading>
                    <AnalysisTable/>
                </Card>
            </Flex>}
        </MainContainer>
    )
})

const MainContainer = styled(Flex)`
    margin-top: 1rem;
    width: 90%;
    height: 100%;
`